import { render, staticRenderFns } from "./Questionnaire.vue?vue&type=template&id=213455a4&scoped=true"
import script from "./Questionnaire.vue?vue&type=script&lang=js"
export * from "./Questionnaire.vue?vue&type=script&lang=js"
import style0 from "./Questionnaire.vue?vue&type=style&index=0&id=213455a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213455a4",
  null
  
)

export default component.exports